import { useCallback } from 'react';
import { RefreshControl, RefreshControlProps } from 'react-native';

import { useRefreshControl } from '../../decorators/withRefreshControl';

interface Props extends Omit<RefreshControlProps, 'refreshing'> {
  isFetching: boolean;
  onRefresh: () => void;
}

export default (props: Props) => {
  const { onRefresh, isFetching, ...others } = props;
  const { onRefreshHOC, showRefreshing } = useRefreshControl({ isFetching });

  const handleRefresh = useCallback(() => {
    onRefreshHOC();
    onRefresh();
  }, [onRefresh, onRefreshHOC]);

  return (
    <RefreshControl
      {...others}
      onRefresh={handleRefresh}
      refreshing={showRefreshing}
    />
  );
};
